import React, { memo, Fragment } from 'react';

import PrescriptionScale from 'js/components/Prescription/DraggableIntervals/PrescriptionScale/PrescriptionScale';
import {
  usePrescriptionJob,
  useMultipleJobs,
} from 'js/components/Prescription/PrescriptionJobContext';
import PropTypes from 'prop-types';
import PrescriptionClassificationScale from '../DraggableIntervals/PrescriptionScale/PrescriptionClassificationScale';

const PrescriptionScaleContainer = ({
  classificationsEnabled,
  variationsEnabled,
  isCustomClassification,
  isBulkPrescription,
  appliedInitialIntervals,
  bulkPrescriptionJobs,
  bulkFuturePrescriptionJobs,
}) => {
  const { prescriptionJob } = usePrescriptionJob();
  const { showCurrentJob } = useMultipleJobs();
  const [isShowingCurrentJob] = showCurrentJob;

  const bulkJobsToShow = isShowingCurrentJob ? bulkPrescriptionJobs : bulkFuturePrescriptionJobs;

  return (
    <Fragment>
      {!(classificationsEnabled && isCustomClassification) && (
        <PrescriptionScale
          layer={prescriptionJob.layer}
          values={prescriptionJob.values}
          intervals={prescriptionJob.intervals}
          overrideAreas={prescriptionJob.overrideAreas}
          classificationsEnabled={classificationsEnabled}
          variationsEnabled={variationsEnabled}
          isBulkPrescription={isBulkPrescription}
          appliedInitialIntervals={appliedInitialIntervals}
          bulkPrescriptionJobs={bulkJobsToShow}
        />
      )}

      {classificationsEnabled && isCustomClassification && (
        <PrescriptionClassificationScale
          layer={prescriptionJob.layer}
          intervals={prescriptionJob.intervals}
          overrideAreas={prescriptionJob.overrideAreas}
          isBulkPrescription={isBulkPrescription}
          appliedInitialIntervals={appliedInitialIntervals}
          bulkPrescriptionJobs={bulkJobsToShow}
        />
      )}
    </Fragment>
  );
};

PrescriptionScaleContainer.propTypes = {
  classificationsEnabled: PropTypes.bool,
  variationsEnabled: PropTypes.bool,
  isCustomClassification: PropTypes.bool,
  isBulkPrescription: PropTypes.bool,
  appliedInitialIntervals: PropTypes.array,
  bulkPrescriptionJobs: PropTypes.object,
  bulkFuturePrescriptionJobs: PropTypes.object,
};

PrescriptionScaleContainer.defaultProps = {};

export default memo(PrescriptionScaleContainer);
